"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerTypeEnum = exports.PartnerType = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const defaultPartnerTypes = [];
exports.PartnerType = [...defaultPartnerTypes, ...(config_1.default.ventureTypeExtensions?.Partner?.partnerType || [])];
exports.PartnerTypeEnum = (0, iotv_v3_types_1.getEnumShape)(exports.PartnerType);
